import { mapGetters } from 'vuex';

export default {
    methods: {
        // each subtype names its size and price differently; a conviction change carries the price of the day
        eventSize(event) {
            const data = event.data || {};
            return data.buy_size ?? data.exit_size ?? data.bonus_size ?? null;
        },
        eventPrice(event) {
            const data = event.data || {};
            return data.buy_price ?? data.target_price ?? data.bonus_price ?? data.current_price ?? null;
        },
        // Aggregates event data for today only (used by dashboard widgets)
        // For asset-specific aggregations over time periods, use server-computed values instead
        aggregateEventData(events) {
            const markets = ['stock', 'crypto'];
            const aggregatesPerMarket = markets.reduce((acc, market) => {
                acc[market] = {
                    sumBuys: 0,
                    sumExits: 0,
                };
                return acc;
            }, {});

            let numberEventsToday = 0;

            const todayMidnightUTC = new Date();
            todayMidnightUTC.setUTCHours(0, 0, 0, 0);

            events.forEach(event => {
                if (event.type !== 'asset') {
                    return;
                }

                const eventDate = this.dateFromISO(event.timestamp);
                const isToday = eventDate >= todayMidnightUTC;

                if (!isToday) {
                    return;
                }

                const asset = this.getAssetByPublicId(event.target_public_id);
                if (!asset) {
                    return;
                }

                const market = asset.market;
                if (!aggregatesPerMarket[market]) {
                    return;
                }

                const buySize = event.data.buy_size || 0;
                const exitSize = event.data.exit_size || 0;

                numberEventsToday += 1;
                if (event.subtype === 'buy') {
                    aggregatesPerMarket[market].sumBuys += buySize;
                } else if (event.subtype === 'exit') {
                    aggregatesPerMarket[market].sumExits += exitSize;
                }
            });

            return {
                ...aggregatesPerMarket,
                numberEventsToday,
            };
        },
        // Asset events that happened after anchorEvent, newest first; the anchor itself is excluded.
        eventsSince(eventList, anchorEvent) {
            if (!anchorEvent) return [];

            // the list is newest first, so everything ahead of the anchor came after it
            const anchorIndex = eventList.findIndex(event => event.public_id === anchorEvent.public_id);
            if (anchorIndex === -1) return [];

            return eventList.slice(0, anchorIndex).filter(event => event.type === 'asset');
        }
    },
    computed: {
        ...mapGetters({
            getAssetByPublicId: 'getAssetByPublicId'
        }),
    }
}